import { Link, useParams } from 'react-router-dom';
import { SUPPORTED_LANGS } from '@/i18n';
import { useTranslation } from 'react-i18next';

export function LocaleLink({ to, children, ...props }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const currentLang = lang && SUPPORTED_LANGS.includes(lang) ? lang : i18n.language || 'en';

  // Don't prefix external URLs or hash links
  const prefixedTo = typeof to === 'string' && to.startsWith('/') && !to.startsWith(`/${currentLang}`)
    ? `/${currentLang}${to}`
    : to;

  return <Link to={prefixedTo} {...props}>{children}</Link>;
}
